import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=2c9a2b62&"
import script from "./InputPrice.vue?vue&type=script&lang=js&"
export * from "./InputPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9a2b62')) {
      api.createRecord('2c9a2b62', component.options)
    } else {
      api.reload('2c9a2b62', component.options)
    }
    module.hot.accept("./InputPrice.vue?vue&type=template&id=2c9a2b62&", function () {
      api.rerender('2c9a2b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputPrice.vue"
export default component.exports